 
import React, { FC } from 'react';
import { SActions } from './styles';
import UpdateEventButton from './UpdateEventButton';
import DeleteEventButton from './DeleteEventButton';
import { useEventById } from 'core/api/events';

type EventActionsProps = {
    eventId: string;
};

const EventActions: FC<EventActionsProps> = ({ eventId }) => {
    const event = useEventById(eventId).data;

    if (!event) {
        return null;
    }

    return (
        <SActions>
            <UpdateEventButton eventId={eventId} />
            <DeleteEventButton eventId={eventId} />
        </SActions>
    );
};

export default EventActions;
